/** Service Desk console: converting a lead into an organisation and a contact (ORG-019, SD-S4-07). */
export const serviceLeadConvert = {
  title: "Convert {{name}} to an organisation",
  hint: "A lead has no company, so name the organisation. The contact starts from the lead; check it before you preview.",
  previewHint: "This is what will be made. Nothing is saved until you convert.",
  working: "Making the organisation and the contact…",
  step: { form: "Step 1 of 2: the organisation and the contact.", preview: "Step 2 of 2: check what will be made.", done: "The lead was converted." },
  converted: "Converted to an organisation",
  convertedTo: "Converted to {{name}}",
  alreadyConverted: "This lead was already converted to",
  actions: {
    open: "Convert to organisation",
    preview: "Preview",
    back: "Back",
    convert: "Convert lead",
  },
  fields: {
    organisation: "Organisation",
    organisationName: "Organisation name",
    organisationNameHint: "The client company or institution. It must be new unless you link to an existing one in the next step.",
    kind: "Kind",
    domains: "E-mail domains",
    domainsHint: "Optional. Separate with spaces or commas, up to {{max}}.",
    contact: "Contact",
    contactName: "Contact name",
    contactEmail: "Contact e-mail",
    contactEmailHint: "The contact needs an e-mail address to sign in.",
    jobTitle: "Job title",
    orgRole: "Role in the organisation",
    role: { org_admin: "Organisation admin", member: "Member" },
  },
  problems: {
    organisationName: "Enter the organisation name (2 to 160 characters).",
    domains: "Use plain domains such as example.com.ph, each once.",
    contactName: "Enter the contact's name.",
    contactEmail: "Enter a valid e-mail address.",
  },
  preview: {
    title: "What will be made",
    new: "New",
    linked: "Existing",
    taken: "Already exists",
    linkBack: "The lead keeps a line on its timeline pointing to the organisation, and the organisation points back to the lead.",
  },
  duplicates: {
    none: "No organisation or contact like this exists yet.",
    title_one: "{{count}} possible duplicate found",
    title_other: "{{count}} possible duplicates found",
    organisation_name: "An organisation with this name already exists:",
    organisation_domain: "This e-mail domain already belongs to:",
    contact_email: "A contact with this e-mail address already exists:",
    link: "Link this lead to the existing organisation and contact",
    linkHint: "Nothing new is made for what already exists. Or go back and change the names.",
  },
  done: {
    created: "{{name}} was created and the contact added.",
    linked: "The lead was linked to the existing {{name}}.",
    openOrganisation: "Open {{name}}",
    openContact: "Open contact {{name}}",
    recorded: "The conversion is on the lead's timeline and in the audit log.",
  },
  origin: {
    prefix: "Converted from lead",
    on: " on {{date}}",
  },
  errors: {
    alreadyConverted: "This lead was already converted. Close this and reload the lead.",
    duplicates: "An organisation or a contact like this already exists. Preview again and link to them, or change the names.",
    rights: "Converting a lead needs both the right to edit leads and to manage organisations.",
    notFound: "This lead is no longer there.",
  },
} as const;
